$(function() {

    let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
        paramObj = {
            action: 'blog_ajax',
            postType: 'post',
            url: myajax,
            catId: 'all',
            searchKeyword: '',
            currentPage: 1
        };

    function loadBlog(paramObj) {
        let postsOffsetTop = $('.js-posts-block').offset().top - $('.page-header').height();
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'POST',
            beforeSend() {
                $('.js-posts-ajax').css({ 'opacity': '.3', 'pointer-events': 'none' });
            },
            success(data) {
                $('html, body').animate({ scrollTop: `${postsOffsetTop}`}, 500);
                $('.js-posts-ajax').html(data);
            },
            complete() {
                $('.js-posts-ajax').css({ 'opacity': '1', 'pointer-events': 'auto' });
            }
        });
    }

    //Filter
    $('body').on('click', '.js-filter-blog', function H() {
        let $this = $(this),
            catID = $this.data('cat-id');
        if (!$this.hasClass('active')) {
            $('.js-filter-blog').removeClass('active');
            $this.addClass('active');
        }
        if (catID) {
            paramObj.catId = catID ? catID : 'all';
        } else {
            let matches = document.body.className.match(/(^|\s)category-(\d+)(\s|$)/);
            if (matches) {
                paramObj.catId = matches[2];
            }
        }
        paramObj.currentPage = 1;
        loadBlog(paramObj);
    });

    //Pagination
    $('.js-posts-ajax').on('click', '.page-numbers', function H(e) {
        let $this = $(this),
            catID = $this.parents('.post-pagination').data('cat-id');
        e.preventDefault();
        if (catID) {
            paramObj.catId = catID ? catID : 'all';
        } else {
            let matches = document.body.className.match(/(^|\s)category-(\d+)(\s|$)/);
            if (matches) {
                paramObj.catId = matches[2];
            }
        }
        paramObj.currentPage = Number($(this).html());
        if ($(this).hasClass('next')) {
            paramObj.currentPage =+ Number($('.current').html()) + 1;
        }
        if ($(this).hasClass('prev')) {
            paramObj.currentPage = +Number($('.current').html()) - 1;
        }
        loadBlog(paramObj);
    });

    // Search
    $(document).on('click', '.js-search-submit', function H(e) {
        e.preventDefault();
        paramObj.paged = 1;
        paramObj.searchKeyword = $('.js-search-keyword').val();
        loadBlog(paramObj);
    });

    $('.js-search-keyword').on('change', function H(e) {
        e.preventDefault();
        paramObj.searchKeyword = $('.js-search-keyword').val();
        paramObj.paged = 1;
        loadBlog(paramObj);
    });

});
